import { I18N_PATH } from './i18n_manager';

import { Translator } from './translator';

const DATABASE_TRANSLATION_PREFIX = "urn:geolinq:translation:database:";
const isDatabaseTranslation = t => t.startsWith(DATABASE_TRANSLATION_PREFIX);

const loadDatabaseTranslation = async (uri) => {
	const id = uri.replace(DATABASE_TRANSLATION_PREFIX, '');
	const locale = null;//getLocale();

	const result = await fetch( `${I18N_PATH}/?urn=${id}&locale=${locale}` );
	const values = await result.json();
	return values;
}

class TranslationManager {

	constructor(options) {
		const { index, storage } = options || {};
		
		this.storage = storage;
		this.index = index;
		console.info("create new translation manager", index, storage);
	}
		
	getLocale() {
		return this.storage.locale;
	}
	
	init(translations) {
		return this.checkTranslations(translations);
	}
	
	initTranslation(translations) {
		const delegate = new TranslationManager({
			storage: this.storage,
			index: this.index.copyOf()
		});
		
		return delegate.init(translations);

	}
	
	async setLocale(requestedLocale, persist) {
		const values = await this.storage.updateLocale(requestedLocale, persist);	
		//TODO: check/reload database values?
			
		await this.index.update(values);
		return values.locale;
	}
		
	hasTranslation(translation) {
		return this.index.hasTranslation(this.getLocale(), translation);
	}
	
	async checkTranslations(translations) {
		const missing = translations
		.filter(key => isDatabaseTranslation(key))
		.filter(key => !this.hasTranslation(key));
		
		if( missing.length > 0 ) {
			console.log( "load translations" );
			//TODO: load
			for(let i = 0; i < missing.length; i++) {
				const { dependencies, values } = await loadDatabaseTranslation(missing[i]);
				console.log(dependencies, values); 
				
				this.translations[locale] = Object.assign(values, this.translations[locale]);
				this.dependencies = Object.assign(dependencies, this.dependencies);				
			}
		} else {
			return this;
		}	
	}
	
	addTranslation(locale, identifier, translation) {
		if( !this.translations.hasOwnProperty(locale) ) {
			this.translations[locale] = {};
		}
		
		this.translations[locale][identifier] = translation;
		
		if( this.translators.hasOwnProperty(identifier) ) {
			this.translators[identifier].addLocale(locale, identifier, translation);
		}
	}
	
	get(translation) {
		if( !translation ) {
			console.warn("No translation given");
		}
		
		let translator = this.index.getTranslator(translation);
		
		if( translator === undefined ) {
			translator = this.create(translation);
			this.index.addTranslator(translation, translator);
		}
		
		return translator;
	}
	
	getPromise(translation) {
		const request = `${DATABASE_TRANSLATION_PREFIX}${translation}`;
		
		return new Promise((resolve, reject) => {
			this.checkTranslations([request])
			.then((value) => {
				resolve(this.get(request));
			})
			.catch(reject);
		});
	}
	
	create( id ) {
		const dependencies = this.index.getDependencies(id);
				
		return new Translator({
			id: id,
			locale: this.storage.locale,
			defaultLocale: this.index.defaultLocale,
			dependencies: [...dependencies],	
			translations: this.index.translations		
		});
	}
	
}

export { 
	TranslationManager
}